import React from "react";

const customSvg = () => (
  <svg
    width="60px"
    height="60px"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.4986 48.315C32.2777 48.6473 31.9928 48.9323 31.6605 49.1531C30.2805 50.0702 28.4185 49.6949 27.5014 48.315C19.8338 36.7771 16 28.6721 16 24C16 16.268 22.268 10 30 10C37.732 10 44 16.268 44 24C44 28.6721 40.1662 36.7771 32.4986 48.315Z"
      fill="#F52A53"
    />
    <circle cx="30" cy="23" r="5" fill="white" />
  </svg>
);

export default customSvg;
